import { render } from "./MarketingSpotlight.vue?vue&type=template&id=439d5106&scoped=true"
import script from "./MarketingSpotlight.vue?vue&type=script&lang=js"
export * from "./MarketingSpotlight.vue?vue&type=script&lang=js"

import "./MarketingSpotlight.vue?vue&type=style&index=0&id=439d5106&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-439d5106"]])

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QList from 'quasar/src/components/item/QList.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import Intersection from 'quasar/src/directives/intersection/Intersection.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QItem,QItemSection,QIcon,QItemLabel,QList,QBtn});qInstall(script, 'directives', {Intersection});
